/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-shadow */
import React, { useEffect, useState } from 'react';
import {
  Box,
  GDSStyleObject,
  Modal,
  Button,
  HeadingText,
  UtilityText,
  StackLayout,
  ParagraphText,
} from '@leagueplatform/genesis-core';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { getAccessToken } from '@leagueplatform/engen-capability-shared-library/src/utils/api';

import * as CONSTANTS from '../../utils/constant';
import { PRIMARY_CARE_LIBRARY_ASSET_KEYS } from '../../types/pcp-library.types';
import { PopOver } from './popOver';
import { InfoModal } from './infoModal';
import { AttentionBox } from '../pcp-attentionBox';

import { pcpLibrary } from '../../pcp-library.config';

export function PrimaryCareProviderLibraryComponent(props: any) {
  const {
    showModal,
    setShowModal,
    configAccountManagement,
    services,
    ubkValue,
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [serivceDown, setServiceDown] = useState(false);
  const [pcpLoading, setPCPLoading] = useState<boolean>(false);

  const [subData, setSubData] = useState<any[]>([]);

  const [serviceName, setServiceName] = useState<any>({});

  const navigate = useNavigate();
  const [depData, setDepData] = useState<any>([]);

  const config = pcpLibrary.getConfig();

  const highmarkURL = config.HIGHMARK_API_URL;

  const getPCPURL = `${highmarkURL}/digital/v3/members/benefits/primaryCarePhysician`;

  const backGrayIcon = useStaticAsset(
    PRIMARY_CARE_LIBRARY_ASSET_KEYS.BACK_GRAY_ICON,
  );

  const serviceIcon = useStaticAsset(
    PRIMARY_CARE_LIBRARY_ASSET_KEYS.SERVICE_DOWN_ICON,
  );

  const handleBackButtonClick = () => {
    if (setShowModal !== undefined) setShowModal(false);
    navigate('/account-management', { replace: true });
  };

  useEffect(() => {
    const serviceObject = services?.find(
      (obj: { name: string }) =>
        obj.name === 'Sapphire' || obj.name === 'Kyruus',
    );
    setServiceName(serviceObject);
  }, [services]);

  const handleLinks = () => {
    const authWebViewUrl = configAccountManagement.SSO_URL_NAMES;
    if (serviceName && serviceName?.name === 'Kyruus') {
      const kyruusURL = configAccountManagement.getSsoUrl(
        authWebViewUrl.KYRUUS,
      );
      configAccountManagement.LinkHandler.handleLink(kyruusURL);
      // window.open(CONSTANTS.KYRUUS_LINK, '_blank');
    } else {
      const sapphireURL = configAccountManagement.getSsoUrl(
        authWebViewUrl.SAPPHIRE,
      );
      configAccountManagement.LinkHandler.handleLink(sapphireURL);
      // window.open(CONSTANTS.SAPPHIRE_LINK, '_blank');
    }
    handleBackButtonClick();
  };

  const getPCPDetails = (url: any) => {
    setPCPLoading(true);

    getAccessToken(url, ubkValue).then((result: any) => {
      setPCPLoading(false);

      const depDetails = result?.members?.filter(
        (item: any) => item.relationship === 'Dependent',
      );
      const subDetails = result?.members?.filter(
        (item: any) => item.relationship === 'Subscriber',
      );

      setSubData(subDetails);
      setDepData(depDetails);

      if (result.errMsg) {
        setServiceDown(true);
      }
    });
  };

  useEffect(() => {
    getPCPDetails(getPCPURL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPCPURL]);

  return (
    <Box>
      <Modal.Root
        open={showModal}
        onOpenChange={() => {
          setShowModal(!showModal);
        }}
      >
        <Modal.Content
          showCloseButton={false}
          padding={{
            '@initial': '30px 150px',
            '@laptop': '30px 100px',
            '@tablet': '30px 30px',
            '@mobile': '0',
            '@mobileLandscape': '30px',
          }}
          css={
            {
              borderRadius: '12px',
              background: '#fff',
              height: 'auto',
              overflowY: 'auto',
              '.genesis.css-3z5yjv': {
                position: 'relative !important',
              },
            } as GDSStyleObject
          }
          width={{ '@initial': '65%', '@laptop': '80%', '@mobile': '100%' }}
          onInteractOutside={(e: any) => e.preventDefault()}
        >
          <Box
            css={{
              height: 'auto',
              minHeight: '500px',
              padding: '$two $three',
              '@mobile': {
                maxWidth: '100vw',
                width: '100%',
                height: '100vh',
                overflow: 'auto !important',
                '.GDS-c-biBNXN': {
                  height: 'auto !important',
                },
              },
            }}
          >
            <Button
              size="small"
              icon={backGrayIcon as string}
              onClick={handleBackButtonClick}
              css={{
                '.GDS-c-PJLV': {
                  fontSize: '$headingThree',
                  '@tablet': {
                    fontSize: '$headingFour',
                  },
                  '@mobile': {
                    fontSize: '$headingFour',
                  },
                  fontWeight: 700,
                },
                '.GDS-c-UazGY': {
                  paddingRight: '25px',
                  marginLeft: '-40px',
                  '@mobile': {
                    paddingRight: '10px',
                    marginLeft: '-5px',
                  },
                },
                background: 'none',
                color: '#66717A',
                padding: '0px',
                outline: 'none !important',
                '&:hover,&:active,&:focus': {
                  background: 'none',
                },
                letterSpacing: 0.25,
                marginBottom: '20px',
                '@mobile': {
                  marginBottom: '10px',
                },
              }}
              data-testid="back-btn"
            >
              {CONSTANTS.BACK_TITLE}
            </Button>

            {pcpLoading ? (
              <LoadingIndicator />
            ) : (
              <>
                <HeadingText
                  level="display"
                  size="sm"
                  css={
                    {
                      fontSize: '30px',
                      fontWeight: 700,
                      padding: '20px 0px 5px 0px',
                      color: '#2C3135',
                      letterSpacing: '0.25px',
                      lineHeight: '40px',
                    } as GDSStyleObject
                  }
                  data-testid="title"
                >
                  {CONSTANTS.PRIMARY_CARE_PROVIDER}
                  <PopOver
                    content={CONSTANTS.PRIMARY_CARE_PROVIDER_TITLE_TOOLTIP}
                    title={CONSTANTS.PRIMARY_CARE_PROVIDER}
                  />
                </HeadingText>

                <Modal.Description>
                  <HeadingText
                    level="display"
                    size="sm"
                    css={
                      {
                        fontSize: '20px',
                        marginTop: '20px',
                        lineHeight: '40px',
                        letterSpacing: '0.25',
                        color: '#2C3135',
                        fontWeight: 600,
                        '@mobile': {
                          lineHeight: '24px',
                        },
                      } as GDSStyleObject
                    }
                    data-testid="test-description"
                  >
                    {CONSTANTS.PRIMARY_CARE_PROVIDER_TITLE}
                    <InfoModal
                      content={
                        CONSTANTS.PRIMARY_CARE_PROVIDER_SUB_TITLE_TOOLTIP
                      }
                      title={CONSTANTS.PRIMARY_CARE_PROVIDER}
                      index={1}
                    />
                  </HeadingText>
                </Modal.Description>

                {serivceDown && (
                  <StackLayout
                    horizontalAlignment="start"
                    css={{ flexDirection: 'row' }}
                    data-testid="select-paperless"
                  >
                    <img
                      src={serviceIcon as string}
                      alt="service icon"
                      width="16px"
                      style={{ margin: '12px 10px 10px 0px' }}
                    />
                    <ParagraphText
                      data-testid="service-header"
                      css={
                        {
                          fontSize: 16,
                          fontStyle: 'normal',
                          fontWeight: 400,
                          lineHeight: '40px',
                          letterSpacing: 0.25,
                          color: '#CE0830',
                        } as GDSStyleObject
                      }
                    >
                      {CONSTANTS.SERVICE_DOWN}
                    </ParagraphText>
                  </StackLayout>
                )}

                {!serivceDown && subData && subData?.length > 0 && (
                  <>
                    {subData[0]?.careProvider?.providerName === '' && (
                      <HeadingText
                        level="display"
                        size="sm"
                        css={
                          {
                            fontSize: '16px',
                            lineHeight: '40px',
                            margin: '0 0 0 0',
                            letterSpacing: '0.25',
                            color: 'rgba(0, 0, 0, 0.80)',
                            fontWeight: '400',
                            '@mobile': {
                              lineHeight: '24px',
                              marginBottom: '10px',
                            },
                          } as GDSStyleObject
                        }
                      >
                        {CONSTANTS.PRIMARY_CARE_PROVIDER_DEPENDENT2_GROUP2}
                        {/* <InfoModal
                          content={
                            CONSTANTS.PRIMARY_CARE_PROVIDER_NOPCP_TOOLTIP
                          }
                          title={CONSTANTS.PRIMARY_CARE_PROVIDER}
                          index={2}
                        /> */}
                      </HeadingText>
                    )}
                    {subData[0]?.careProvider?.providerName !== '' && (
                      <HeadingText
                        level="display"
                        size="sm"
                        css={
                          {
                            fontSize: '16px',
                            lineHeight: '40px',
                            letterSpacing: '0.25',
                            color: 'rgba(0, 0, 0, 0.80)',
                            fontWeight: '400',
                            '@mobile': {
                              lineHeight: '24px',
                            },
                          } as GDSStyleObject
                        }
                        data-testid="service-body1"
                      >
                        {subData[0]?.careProvider?.providerName}
                      </HeadingText>
                    )}
                  </>
                )}

                {!serivceDown &&
                  depData &&
                  depData?.length > 0 &&
                  subData?.length <= 0 && (
                    <>
                      {depData[0]?.careProvider?.providerName === '' && (
                        <HeadingText
                          level="display"
                          size="sm"
                          css={
                            {
                              fontSize: '16px',
                              lineHeight: '40px',
                              margin: '0 0 0 0',
                              letterSpacing: '0.25',
                              color: 'rgba(0, 0, 0, 0.80)',
                              fontWeight: '400',
                              '@mobile': {
                                lineHeight: '24px',
                                marginBottom: '10px',
                              },
                            } as GDSStyleObject
                          }
                        >
                          {CONSTANTS.PRIMARY_CARE_PROVIDER_DEPENDENT2_GROUP2}
                          {/* <InfoModal
                            content={
                              CONSTANTS.PRIMARY_CARE_PROVIDER_NOPCP_TOOLTIP
                            }
                            title={CONSTANTS.PRIMARY_CARE_PROVIDER}
                            index={2}
                          /> */}
                        </HeadingText>
                      )}
                      {depData[0]?.careProvider?.providerName !== '' && (
                        <HeadingText
                          level="display"
                          size="sm"
                          css={
                            {
                              fontSize: '16px',
                              lineHeight: '40px',
                              letterSpacing: '0.25',
                              color: 'rgba(0, 0, 0, 0.80)',
                              fontWeight: '400',
                              '@mobile': {
                                lineHeight: '24px',
                              },
                            } as GDSStyleObject
                          }
                          data-testid="service-body1"
                        >
                          {depData[0]?.careProvider?.providerName}
                        </HeadingText>
                      )}
                    </>
                  )}

                {/* dependent information */}
                {depData &&
                  depData?.length > 0 &&
                  subData &&
                  subData?.length > 0 && (
                    <>
                      <HeadingText
                        level="display"
                        size="sm"
                        css={
                          {
                            marginTop: '10px',
                            fontSize: '20px',
                            lineHeight: '40px',
                            letterSpacing: '0.25',
                            color: '#2C3135',
                            fontWeight: '600',
                            '@mobile': {
                              lineHeight: '24px',
                              marginBottom: '10px',
                            },
                          } as GDSStyleObject
                        }
                      >
                        {CONSTANTS.PRIMARY_CARE_PROVIDER_DEPENDENT}
                      </HeadingText>
                      <Modal.Description>
                        <HeadingText
                          level="display"
                          size="sm"
                          css={
                            {
                              fontSize: '16px',
                              lineHeight: '40px',
                              letterSpacing: '0.25',
                              color: 'rgba(0, 0, 0, 0.80)',
                              fontWeight: '400',
                              '@mobile': {
                                lineHeight: '24px',
                                marginBottom: '10px',
                              },
                            } as GDSStyleObject
                          }
                        >
                          {CONSTANTS.PRIMARY_CARE_PROVIDER_DEPENDENT_CONTENT}
                        </HeadingText>
                      </Modal.Description>
                    </>
                  )}

                {subData &&
                  subData?.length > 0 &&
                  depData &&
                  depData?.length > 0 &&
                  depData?.map((item: any) => (
                    <>
                      <HeadingText
                        level="display"
                        size="sm"
                        css={
                          {
                            marginTop: '20px',
                            fontSize: '18px',
                            lineHeight: '40px',
                            letterSpacing: '0.25',
                            color: '#2C3135',
                            fontWeight: '600',
                            '@mobile': {
                              lineHeight: '24px',
                              marginBottom: '10px',
                            },
                          } as GDSStyleObject
                        }
                        data-testid="test-description"
                      >
                        {`${item.firstName} ${item.middleName} ${
                          item.lastName
                        }${`'s PCP`}`}
                      </HeadingText>
                      {item?.careProvider?.providerName !== '' && (
                        <HeadingText
                          level="display"
                          size="sm"
                          css={
                            {
                              fontSize: '16px',
                              lineHeight: '40px',
                              margin: '0 0 0 0',
                              letterSpacing: '0.25',
                              color: 'rgba(0, 0, 0, 0.80)',
                              fontWeight: '400',
                              '@mobile': {
                                lineHeight: '24px',
                                marginBottom: '10px',
                              },
                            } as GDSStyleObject
                          }
                        >
                          {CONSTANTS.PRIMARY_CARE_PROVIDER_DEPENDENT1_GROUP1}
                        </HeadingText>
                      )}

                      {item?.careProvider?.providerName === '' && (
                        <HeadingText
                          level="display"
                          size="sm"
                          css={
                            {
                              fontSize: '16px',
                              lineHeight: '40px',
                              margin: '0 0 0 0',
                              letterSpacing: '0.25',
                              color: 'rgba(0, 0, 0, 0.80)',
                              fontWeight: '400',
                              '@mobile': {
                                lineHeight: '24px',
                                marginBottom: '10px',
                              },
                            } as GDSStyleObject
                          }
                        >
                          {CONSTANTS.PRIMARY_CARE_PROVIDER_DEPENDENT2_GROUP2}
                          <InfoModal
                            content={
                              CONSTANTS.PRIMARY_CARE_PROVIDER_NOPCP_TOOLTIP
                            }
                            title={CONSTANTS.PRIMARY_CARE_PROVIDER}
                            index={2}
                          />
                        </HeadingText>
                      )}
                    </>
                  ))}

                {/* PCP select section */}

                <HeadingText
                  level="display"
                  size="sm"
                  css={
                    {
                      marginTop: '20px',
                      fontSize: '20px',
                      lineHeight: '40px',
                      letterSpacing: '0.25',
                      color: '#2C3135',
                      fontWeight: '600',
                      '@mobile': {
                        lineHeight: '24px',
                        marginBottom: '10px',
                      },
                    } as GDSStyleObject
                  }
                >
                  {CONSTANTS.PRIMARY_CARE_PROVIDER_CONTENT_TITLE}
                </HeadingText>
                <UtilityText>
                  <ol
                    style={{
                      lineHeight: '23px',
                      listStyle: 'none',
                    }}
                  >
                    {' '}
                    <li>
                      <HeadingText
                        level="display"
                        size="sm"
                        css={
                          {
                            fontSize: '16px',
                            lineHeight: '40px',
                            letterSpacing: '0.25',
                            color: 'rgba(0, 0, 0, 0.80)',
                            fontWeight: '400',
                            '@mobile': {
                              lineHeight: '24px',
                              marginBottom: '10px',
                            },
                          } as GDSStyleObject
                        }
                      >
                        1.{' '}
                        <span
                          style={{
                            cursor: 'pointer',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: '#0074C9',
                          }}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              setIsOpen(true);
                            }
                          }}
                          onClick={() => {
                            setIsOpen(true);
                          }}
                        >
                          {CONSTANTS.PRIMARY_CARE_PROVIDER_CONTENT_BODY1}
                        </span>
                        {serviceName?.name === 'Kyruus'
                          ? CONSTANTS.PRIMARY_CARE_PROVIDER_KYRUUS_CONTENT_BODY
                          : CONSTANTS.PRIMARY_CARE_PROVIDER_CONTENT_BODY2}
                      </HeadingText>
                    </li>
                    <li>
                      <HeadingText
                        level="display"
                        size="sm"
                        css={
                          {
                            fontSize: '16px',
                            lineHeight: '40px',
                            letterSpacing: '0.25',
                            color: 'rgba(0, 0, 0, 0.80)',
                            fontWeight: '400',
                            '@mobile': {
                              lineHeight: '24px',
                            },
                          } as GDSStyleObject
                        }
                      >
                        <Box
                          css={
                            {
                              display: 'flex',
                              flexDirection: 'row',
                            } as GDSStyleObject
                          }
                        >
                          2.{' '}
                          <HeadingText
                            level="display"
                            size="sm"
                            css={
                              {
                                fontSize: '16px',
                                lineHeight: '40px',
                                letterSpacing: '0.25',
                                marginLeft: '3px',
                                color: 'rgba(0, 0, 0, 0.80)',
                                fontWeight: '400',
                                '@mobile': {
                                  lineHeight: '24px',
                                },
                              } as GDSStyleObject
                            }
                          >
                            <span
                              style={{
                                fontSize: '16px',
                                fontWeight: 600,
                              }}
                            >
                              {CONSTANTS.PRIMARY_CARE_PROVIDER_CONTENT_BODY3}
                            </span>
                            <span
                              style={{
                                fontSize: '16px',
                              }}
                            >
                              {CONSTANTS.PRIMARY_CARE_PROVIDER_CONTENT_BODY4}
                            </span>
                          </HeadingText>
                        </Box>
                      </HeadingText>
                    </li>
                  </ol>
                </UtilityText>
                <HeadingText
                  level="display"
                  size="sm"
                  css={
                    {
                      marginTop: '15px',
                      fontSize: '16px',
                      lineHeight: '40px',
                      letterSpacing: '0.25',
                      color: 'rgba(0, 0, 0, 0.80)',
                      fontWeight: '400',
                      '@mobile': {
                        lineHeight: '24px',
                      },
                    } as GDSStyleObject
                  }
                >
                  <span
                    style={{
                      fontSize: '16px',
                      fontWeight: 600,
                    }}
                  >
                    {CONSTANTS.PRIMARY_CARE_PROVIDER_CONTENT1}
                  </span>
                  {CONSTANTS.PRIMARY_CARE_PROVIDER_CONTENT2}
                </HeadingText>
              </>
            )}
          </Box>
        </Modal.Content>
      </Modal.Root>
      <AttentionBox
        serviceName={serviceName}
        openTermCondition={isOpen}
        handleAcceptFun={handleLinks}
        handleDeclineFun={() => {
          setIsOpen(false);
        }}
      />
    </Box>
  );
}
